import { createActionTypes } from "../../helpers/utils/createActionTypes";

export const FILTER_BAR = {
    GET_FILTER_DATA: createActionTypes("GET_FILTER_DATA"),
}